import React, { Dispatch, FC, SetStateAction, useCallback, useState } from "react";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

import { DocumentData } from "@/util/interfaces/DocumentData";
import { FileData } from "@/util/interfaces/FileData";

type StepTwoFileProps = {
  index: number;
  file: FileData;
  setInternalFiles: Dispatch<SetStateAction<FileData[]>>;
  currentFile?: DocumentData;
};

const StepTwoFileItem: FC<StepTwoFileProps> = ({
  index,
  file,
  setInternalFiles,
  currentFile,
}): JSX.Element => {
  const [isTruncated, setIsTruncated] = useState(false);

  const checkIsTruncatedRef = useCallback((node: HTMLParagraphElement | null) => {
    if (!node) return;
    setIsTruncated(node.scrollWidth > node.clientWidth);
  }, []);

  return (
    <FormControlLabel
      key={index}
      sx={{
        marginRight: 0,
        width: isTruncated ? "calc(100% - 39px)" : "100%",
        "& .MuiTypography-root": {
          width: "100%",
        },
      }}
      label={
        <Box display="flex" gap="8px" justifyContent="space-between" alignItems="center">
          <Typography
            ref={checkIsTruncatedRef}
            component="p"
            className="text-overflow-ellipsis"
            title={isTruncated ? file.file.name : undefined}
          >
            {file.file.name}
          </Typography>
          {file.override &&
            currentFile &&
            file.isChecked &&
            file.file.name !== currentFile?.documentName && (
              <Box
                data-testid="warning-icon"
                title={`This file's name does not match, uploading will override the current version but keep the original file's name`}
              >
                <Icon icon="ep:warning-filled" height={15} color="333333" />
              </Box>
            )}
          {file.isCompleted && (
            <Box data-testid="completion-icon">
              <Icon
                icon="akar-icons:check"
                height={20}
                style={{
                  color: "green",
                }}
              />
            </Box>
          )}
        </Box>
      }
      control={
        <Checkbox
          checked={file.isChecked}
          onChange={(_, checked) =>
            setInternalFiles((prev) => {
              return prev.map((f) => {
                if (f.file.name === file.file.name) {
                  return { ...f, isChecked: checked };
                }
                return f;
              });
            })
          }
        />
      }
    />
  );
};

export default StepTwoFileItem;
